<div #container *ngIf="actionParams?.length" class="actionItem" tabindex="0">
    <ul class="list-group" *ngFor="let param of actionParams; let i=index">
        <li class="list-group-item" (click)="onSelect(param?.name)"><span style="cursor: pointer;"><i class="fa {{ param?.icon }}" title="{{ param?.name }}"></i> {{ param?.name }}</span></li>
      </ul>
  </div>